import { ListRenderItem } from '@shopify/flash-list';
import { Page } from 'components/Page';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { ListItem } from 'screens/AssetsScreen/LocalAssets/ListItem';
import {
  selectAssetsTotal,
  selectFilteredAssetsListIds,
  selectFilteredAssetsListTotal,
} from 'store/assets/selectors';

import { LocalAssetsHeader } from './LocalAssetsHeader';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { List } from 'components/List';

type NavigationProps = NativeStackScreenProps<
  NavigationStacks[Stacks.OFFLINE],
  Screens.OFFLINE_ASSETS
>;

type Props = {
  navigation: NavigationProps['navigation'];
  inPages: boolean;
};

export const LocalAssets: React.FC<Props> = ({ navigation, inPages }) => {
  const assetIds = useSelector(selectFilteredAssetsListIds);
  const allAssetsTotal = useSelector(selectAssetsTotal);
  const currentAssetsTotal = useSelector(selectFilteredAssetsListTotal);
  const filterMessage =
    currentAssetsTotal !== allAssetsTotal
      ? `${currentAssetsTotal} of ${allAssetsTotal} Properties Shown`
      : null;

  const handleItemPress = React.useCallback(
    (itemId: string) => {
      navigation.navigate(Screens.OFFLINE_ASSET, { id: itemId });
    },
    [navigation],
  );

  const renderItem: ListRenderItem<string> = React.useMemo(
    () =>
      ({ item }) => <ListItem id={item} handleItemPress={handleItemPress} />,
    [handleItemPress],
  );

  return (
    <Page header={<LocalAssetsHeader inPages={inPages} />}>
      <List
        data={assetIds}
        keyExtractor={(item) => item}
        ListFooterComponent={
          filterMessage ? (
            <View style={styles.footerContainer}>
              <Txt>{filterMessage}</Txt>
            </View>
          ) : undefined
        }
        ItemSeparatorComponent={() => (
          <View style={{ height: theme.padding / 2 }} />
        )}
        renderItem={renderItem}
      />
    </Page>
  );
};

const styles = StyleSheet.create({
  footerContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.grid * 2,
  },
});
